import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-back-nav',
  templateUrl: './back-nav.component.html',
  styleUrls: ['./back-nav.component.scss']
})
export class BackNavComponent implements OnInit {

  constructor(private appState: AppState, private route: ActivatedRoute, private router: Router) { }

  @Input()
  public defaultLink = '/';

  @Input()
  public link: string | null = null;

  @Input()
  public linkText = 'Vissza';

  ngOnInit(): void {
  }

  getLocation() {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    if (returnUrl)
    {
      if (returnUrl === 'settings')
        return '/settings';
      else if (returnUrl === 'main')
        return '/';
    }

    if (this.link)
      return this.link;

    if (!this.appState.prevLocation?.value) return this.defaultLink;

    //all other cases we return the previous location
    return this.appState.prevLocation?.value;
  }

  getQueryParams() {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    
    if (this.link && returnUrl)
    {
      return {returnUrl: returnUrl};
    }

    return {};
  }
}
